import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useCallback } from 'react';
import { fetchBlogById } from '../../redux/blog/blogSlice';
import { AppDispatch, RootState } from '../../redux';

const useFetchBlogDetailsById = (id: string) => {
  const dispatch = useDispatch<AppDispatch>();
  const { post, status, loading } = useSelector((state: RootState) => state.blog);
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchBlog = useCallback(async () => {
    try {
      await dispatch(fetchBlogById(id));
    } finally {
      setIsLoaded(true);
    }
  }, [dispatch, id]);

  useEffect(() => {
    fetchBlog();
  }, [fetchBlog]);

  return { post, status, isLoaded, loading };
};

export default useFetchBlogDetailsById;
